import { Basics } from "../_app/cuchillo/core/Basics";
import { Metrics } from "../_app/cuchillo/core/Metrics";
import { Sizes } from "../_app/cuchillo/core/Sizes";
import Flappy from "./Flappy";
import SoundController from "./SoundController";

export default class Bird {
  constructor(callback) {
  
    this.position = {
      x: 80 * Sizes.RATIO,
      y: 212 * Sizes.RATIO
    };
    this.size = {
      width: 85 * Sizes.RATIO,
      height: 70 * Sizes.RATIO
    };
    this.size = {
      offset: 20 * Sizes.RATIO,
      width: 78 * Sizes.RATIO,
      height: 67 * Sizes.RATIO,
      hitWidth: 38 * Sizes.RATIO,
      hitHeight: 27 * Sizes.RATIO
    };
    this.speed = 0;
    this.jumpForce = 0;
    this.isJumping = false;
    this.isDie = false;
    this.tick = 0;
    this.currentFrame = 0;
    this.idTimer = null;
    
    this.frames = [
      { image: new Image(), src: BIRDS[0], isLoaded: false },
      { image: new Image(), src: BIRDS[1], isLoaded: false },
      { image: new Image(), src: BIRDS[2], isLoaded: false }
    ];
    this.flapSound = new Audio("/assets/audio/flap.mp3");
    this.dieSound = new Audio("/assets/audio/die.mp3");
    this.hitSound = new Audio("/assets/audio/hit.mp3");
    this.preload(callback);
  }

  preload(callback) {
    const promises = this.frames.map((frame) => {
      return new Promise((resolve) => {
        frame.image.onload = () => {
          frame.isLoaded = true;
          resolve();
        };
        frame.image.src = frame.src;
      });
    });

    Promise.all([...promises]).then(callback);
  }

  reset() {
    this.position = {
      x: 80 * Sizes.RATIO,
      y: 212 * Sizes.RATIO
    };
    this.speed = 0;
    this.jumpForce = 0;
    this.isJumping = false;
    this.isDie = false;
  }

  jump() {
    if(this.isDie) return;
    
    this.jumpForce = 5 * Sizes.RATIO;

    this.isJumping = true;
    SoundController.playSound("flap");
  }

  die() {
    this.isDie = true;
    SoundController.playSound("hit");
    this.idTimer = setTimeout(() => {  SoundController.playSound("die"); }, 400);
  }

  update() {
    if (this.isJumping) {
      this.isJumping = false;
      this.speed = 0;
    }

    this.speed = (this.speed + Metrics.GRAVITY) - this.jumpForce;
    this.position.y += this.speed;
    this.jumpForce *= 0.4;

    if (this.isDie) {
      this.position.x -= Flappy.speed;
    }
  }

  draw(ctx) {
    this.tick++;

    const angle = this.speed < 0 ? Math.atan2(this.speed, 10) * (180 / Math.PI) : Math.atan2(this.speed * 0.15, 10) * (180 / Math.PI);
    const adjustedAngle = this.speed > 0 ? Math.min(angle, 30) : Math.max(angle, -90);

    ctx.save();
    const centerX = this.position.x + this.size.width / 2;
    const centerY = this.position.y + this.size.height / 2;
    ctx.translate(centerX, centerY);
    ctx.rotate((adjustedAngle * Math.PI) / 180);
    ctx.drawImage(
      this.frames[Basics.currentBird].image,
      -this.size.width / 2,
      -this.size.height / 2,
      this.size.width,
      this.size.height
    );
    ctx.restore();
    
    
    /*if(this.tick % 10 === 0) {  
      this.currentFrame = (this.currentFrame + 1) % this.frames.length;
    }*/
  }

  dispose() {
    clearTimeout(this.idTimer);
    // Eliminar referencias a los elementos del DOM (imágenes)
    this.frames.forEach((frame) => {
      frame.image.src = "";
      frame.image.onload = null;
    });
  
    // Liberar recursos de los objetos de sonido
    this.flapSound.pause();
    this.flapSound.src = "";
    this.flapSound = null;
  
    this.dieSound.pause();
    this.dieSound.src = "";
    this.dieSound = null;
  
    this.hitSound.pause();
    this.hitSound.src = "";
    this.hitSound = null;
  
    // Restablecer propiedades a sus valores iniciales o null
    this.position = null;
    this.size = null;
    this.speed = null;
    this.jumpForce = null;
    this.isJumping = null;
    this.isDie = null;
    this.tick = null;
    this.currentFrame = null;
    this.frames = null;
  }
}
